import { formatDateValue } from '@components/FieldFilter';
import { DateCondition, getDateFromFilter } from '@fabric-ui/components';
import { dateFormat as defaultDateFormat } from './constants';

export const formatTimeRange = (timeRange: DateCondition, dateFormat = defaultDateFormat) => {
  const dateObject = getDateFromFilter(timeRange);
  return formatDateValue({ value: dateObject.value, dateFormat });
};
